module.exports = __webpack_public_path__ + "static/media/govt.24f6aa11.jpeg";